import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/app.css';
import './styles/documentConclusion.css';
import './styles/labTrend.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element #root was not found');
}

// The pre-React static build of this app registered a service worker
// (repo-root sw.js); the current Vite build doesn't reference it or ship
// any service worker of its own (dist/ has no sw.js), but a browser that
// visited this origin back then still has that old one permanently
// installed — silently intercepting requests with a cache that has
// nothing to do with the current app. Clean it up on every load so nobody
// stays stuck with it.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(regs => regs.forEach(reg => reg.unregister()));
}

// This is an app-like, responsive interface: every task must fit the device
// width without browser magnification. iOS Safari ignores `user-scalable=no`
// in some contexts, so also cancel its legacy gesture events. Vertical
// scrolling remains enabled by the root `touch-action: pan-y` rule.
const preventBrowserZoom = (event: Event) => event.preventDefault();
document.addEventListener('gesturestart', preventBrowserZoom, { passive: false });
document.addEventListener('gesturechange', preventBrowserZoom, { passive: false });

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
